import Vue from 'vue'
import Vuex from 'vuex'

import vuejsStorage from 'vuejs-storage'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'token'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    let initToken = {
      validation: false,
      tokenId: '',
      tokenAuth: '',
      expireTime: '',
      type: '',
      timeout: ''
    }

    const store = new Vuex.Store({
      state: {
        token: initToken
      },
      getters: {
        getState: state => {
          return state.token
        },
        getTokenId: state => {
          return state.token.tokenId
        },
        getTokenAuth: state => {
          return state.token.tokenAuth
        },
        getTokenValidation: state => {
          return state.token.validation
        },
        getTokenExprieTime: state => {
          return state.token.expireTime
        },
        getTokenType: state => {
          return state.token.type
        },
        getTokenTimeout: state => {
          return state.token.timeout
        }
      },
      mutations: {
        // 토큰 저장
        REGISTER (state, token) {
          state.token = token
        },
        // 토큰 제거
        DELETE (state) {
          state.token = {
            validation: false,
            tokenId: '',
            tokenAuth: '',
            expireTime: '',
            type: '',
            timeout: ''
          }
        }
      },
      plugins: [
        vuejsStorage({
          keys: ['token'],
          namespace: 'mmp-token-info',
          driver: vuejsStorage.drivers.sessionStorage
        })
      ]
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/token.js